import { AnswerAsk } from '../interface'

/**
 * ルートカード以外の既存カードは含まない。そのためanswersとorderedAnswersの数は一致しない事がある。
 * 会話の選択肢に既存カードが選択された場合は画面遷移した先でそのカードがルートカードとして
 * orderedAnswersに含まれてくる。
 */
export function generateOrderedAnswersExcludeAnotherCards(
  keyAssignmentAnswers: Record<string, AnswerAsk>,
  answerIds: string[]
): AnswerAsk[] {
  const orderedAnswerIds = generateOrderedAnswerIds(keyAssignmentAnswers, answerIds)
  return orderedAnswerIds.reduce<AnswerAsk[]>((acc, answerId) => {
    if (keyAssignmentAnswers[answerId]) {
      acc.push(keyAssignmentAnswers[answerId])
    }
    return acc
  }, [])
}

export function generateOrderedAnswerIds(
  keyAssignmentAnswers: Record<string, AnswerAsk>,
  answerIds: string[],
  parentFoundAllAnswerIds: string[] = []
): string[] {
  const result: string[] = []

  for (const answerId of answerIds) {
    const answer = keyAssignmentAnswers[answerId]
    if (!answer || result.includes(answerId) || parentFoundAllAnswerIds.includes(answerId)) {
      continue
    }
    result.push(answerId)
    for (const action of answer.actions?.actions || []) {
      if (!action?.id || !keyAssignmentAnswers[action.id]) {
        continue
      }
      const a = keyAssignmentAnswers[action.id]
      if (!a || result.includes(a.id) || parentFoundAllAnswerIds.includes(answerId)) {
        continue
      }
      const mergedParentFoundAllAnswerIds = [...result, ...parentFoundAllAnswerIds]
      const carouselChildResult = generateOrderedAnswerIds(
        keyAssignmentAnswers,
        [a.id],
        mergedParentFoundAllAnswerIds
      )
      result.push(...carouselChildResult)
    }

    for (const content of answer.contents || []) {
      for (const carouselAction of content.carousel?.actions || []) {
        for (const action of carouselAction?.value?.actions || []) {
          if (!action?.id || !keyAssignmentAnswers[action.id]) {
            continue
          }
          const a = keyAssignmentAnswers[action.id]
          if (!a || result.includes(a.id) || parentFoundAllAnswerIds.includes(answerId)) {
            continue
          }
          const mergedParentFoundAllAnswerIds = [...result, ...parentFoundAllAnswerIds]
          const carouselChildResult = generateOrderedAnswerIds(
            keyAssignmentAnswers,
            [a.id],
            mergedParentFoundAllAnswerIds
          )
          result.push(...carouselChildResult)
        }
      }
    }
  }

  return result
}
